import { images, links, TID } from "@/data";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <section className="about section" id="about">
      <div className="container">
        <div className="about__head">
          <h2 className="about__title">Every travel segment, served uniquely with care.</h2>
          <p className="about__text">
            Hi Tours Group is a family of specialized travel brands: Hi DMC, Hi Tours, and Hi Offsite,
            each built to serve a distinct part of the industry. Whether it’s the perfect holiday,
            expert destination management, or an unforgettable team offsite, your journey gets the
            attention it deserves.
          </p>
          <div className="about__cta">
            <Link to="/about" className="btn btn--solid" data-testid={TID.aboutCompany}>
              <span className="btn__dot" />About Us
            </Link>
          </div>
        </div>

        <div className="founder-note">
          <div className="founder-note__leaders">
            <div className="leader">
              <img className="leader__photo" src={images.hunarSyal} alt="Hunar Syal, Chief Executive Officer" loading="lazy" />
              <div className="leader__meta">
                <span className="leader__name">Hunar Syal</span>
                <span className="leader__role">Chief Executive Officer</span>
              </div>
            </div>
            <div className="leader">
              <img className="leader__photo" src={images.premChairman} alt="Prem Syal, Founder & Chairman" loading="lazy" />
              <div className="leader__meta">
                <span className="leader__name">Prem Syal</span>
                <span className="leader__role">Founder &amp; Chairman</span>
              </div>
            </div>
          </div>

          <div className="founder-note__body">
            <span className="founder-note__label">A Message From Our CEO</span>
            <img className="founder-note__quote-icon" src={images.founderQuote} alt="" aria-hidden="true" />
            <h3 className="founder-note__heading">Leading a new era of travel.</h3>
            <p className="founder-note__message">
              At Hi Tours Group, we believe travel has the power to bring the world closer together. For
              three decades we have paired deep local expertise with a relentless drive to innovate,
              building brands that make every journey seamless, meaningful, and truly unforgettable. As we
              look ahead, our ambition is simple: to shape a smarter, more human way to explore the world.
            </p>
            <div className="founder-note__sign">
              <span className="founder-note__signature-text">Hunar Syal</span>
              <span className="founder-note__role">Chief Executive Officer, Hi Tours Group</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
